import React, { useCallback } from 'react';
import { IEditForm } from '../../types/interfaces/IEditForm';
import { TextField, Typography, Box } from '@material-ui/core';
import { stylesConstants } from '../../styles/stylesConstants';

const InputFormDescription: React.FC<IEditForm> = ({
  onChange,
  value,
  fieldName,
  multiline,
  label,
  textFieldType,
  error,
  errorText,
}) => {
  const handleOnChange = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
      onChange ? onChange(fieldName, event.target.value) : () => null,
    [fieldName, onChange],
  );

  return (
    <>
      {label && (
        <Box marginBottom={1}>
          <Typography variant="subtitle2">{label}</Typography>
        </Box>
      )}
      <TextField
        id={fieldName}
        name={fieldName}
        onChange={handleOnChange}
        value={value || ''}
        multiline={multiline}
        rows={multiline ? 6 : 1}
        type={textFieldType}
        error={error}
        helperText={errorText}
        style={{
          width: stylesConstants.inputFormWidth,
        }}
      />
    </>
  );
};

export default InputFormDescription;
